import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../api/api';
import { toast } from 'react-toastify';
import PublicHeader from '../layout/PublicHeader';
import PublicFooter from '../layout/PublicFooter';
import '../App.css';




export default function RegisterNewOrgPage() {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState(null); // { orgId, orgName }
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const params = new URLSearchParams(window.location.search);
  const inviteOrgId = params.get('inviteOrgId');
  const inviteRole = params.get('role') || 'org:view';
  const invitedEmail = params.get('email') || '';
  // User fields
  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName]  = useState('');
  const [email,     setEmail]     = useState(invitedEmail);
  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [agree,     setAgree]     = useState(false);

  // Org fields
  const [organization, setOrganization] = useState('');
  const [website,      setWebsite]      = useState('');


  const back = () => nav('/login', { replace: true });
  // If you navigate after successful submit:
  const navigate = useNavigate();


  const submit = async (e) => {
      e.preventDefault();
      setSubmitting(true);
      setError(null);

      try {
        const payload = inviteOrgId
            ? {
                user: {
                  firstName,
                  lastName,
                  email,
                  password
                },
                join: {
                  orgId: inviteOrgId,
                  role: inviteRole
                }
              }
            : {
                user: {
                  firstName,
                  lastName,
                  email,
                  password
                },
                org: {
                  organization,
                  website
                }
              };


        // IMPORTANT: apiFetch returns parsed JSON (not a Response)
        const out = await apiFetch('/auth/register', {
          method: 'POST',
          body: {
            ...payload.user,
            inviteOrgId,
            inviteRole
          }
        });

        toast.success(
          'Registration successful. Please check your email to verify your account.'
        );
        navigate('/check-your-email');

      } catch (err) {
        console.error('register/new failed:', err);
        setError(err?.message || 'Registration failed');
      } finally {
        setSubmitting(false);
      }
    }


  if (success) {
    return (
      <div style={wrap}>
      {error && <div style={{ color: 'crimson', marginBottom: 8 }}>{error}</div>}

        <div style={panel}>
          <h2 style={{marginTop:0}}>You’re all set 🎉</h2>
          <p>
            Organization <b>{success.orgName}</b> was created and you’re the owner of it.
          </p>
          <div style={{display:'flex', gap:8, justifyContent:'flex-end', marginTop:12}}>
            <button
              style={btnLight}
              onClick={() => nav('/admin', { replace: true })}
            >
              Go to Dashboard
            </button>
            <button
              style={btnPrimary}
              onClick={() => nav(`/orgs/${success.orgId}/invite`, { replace: true })}
            >
              Invite Teammates
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
        <PublicHeader />
        <div className="form-container" style={{maxWidth: "700px"}}>
        <style>{`
          .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
          @media (max-width: 750px) {
            .grid2 { grid-template-columns: 1fr; }
          }
        `}</style>

        <h2 style={{marginTop:0}}>Create your account & organization</h2>
        <form onSubmit={submit}>
          {/* Row 1: First / Last (2 cols) */}
          <div className="grid2">
            <div style={row}>
              <label style={label}>First name*</label>
              <input
                style={input}
                value={firstName}
                onChange={e=>setFirstName(e.target.value)}
                autoComplete="given-name"
                required
              />
            </div>
            <div style={row}>
              <label style={label}>Last name*</label>
              <input
                style={input}
                value={lastName}
                onChange={e=>setLastName(e.target.value)}
                autoComplete="family-name"
                required
              />
            </div>
          </div>
          {/* Row 2: Password / Confirm (2 cols) */}
          <div className="grid2">
            <div style={row}>
              <label style={label}>Password*</label>
              <input
                style={input}
                type="password"
                value={password}
                onChange={e=>setPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
            <div style={row}>
              <label style={label}>Confirm password*</label>
              <input
                style={input}
                type="password"
                value={confirm}
                onChange={e=>setConfirm(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
          </div>

          {/* Row 3: Organization name / Email  (2 cols)*/}
          <div className="grid2">
            {!inviteOrgId && (
              <div style={row}>
                <label style={label}>Organization name*</label>
                <input
                  style={input}
                  value={organization}
                  onChange={e=>setOrganization(e.target.value)}
                  required
                />
              </div>
            )}
            <div style={row}>
              <label style={label}>Work email*</label>
              <input
                style={input}
                type="email"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
          </div>


          {/* Row 4: Website */}
          <div style={row}>
            <label style={label}>Website</label>
            <input
              style={input}
              placeholder="https://example.com"
              value={website}
              onChange={e=>setWebsite(e.target.value)}
              autoComplete="url"
            />
          </div>

          {/* Row 4: Terms & Privacy */}
          <div style={{display:'flex', justifyContent:'center'}}>
            <input
              id="agree"
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <label style={label}>I agree to the Terms &amp; Privacy.</label>
          </div>
          {/* Actions */}
          <div style={{display:'flex', justifyContent:'center'}}>
            <button type="button" onClick={back} style={btnLight}>Back</button>&nbsp;&nbsp;&nbsp;&nbsp;
            <button type="submit" style={btnPrimary} disabled={busy}>
              {busy ? 'Submitting…' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const wrap = { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh', background:'#f7f8fb', padding:16 };
const panel = { width:560, maxWidth:'96vw', background:'#fff', border:'1px solid #eee', borderRadius:12, padding:16, boxShadow:'0 10px 30px rgba(0,0,0,.06)' };
const row = { display:'flex', flexDirection:'column' };
const label = { fontSize:13, color:'#555', marginBottom:6 };
const input = { padding:'10px 12px', border:'1px solid #ddd', borderRadius:8 };
const btnPrimary = { border:0, background:'#0f62fe', color:'#fff', borderRadius:8, padding:'10px 14px', cursor:'pointer' };
const btnLight = { border:'1px solid #ddd', background:'#f5a623', borderRadius:8, padding:'10px 14px', cursor:'pointer' };
